// ============================================
// STYLES - PROCESSING MODAL
// ============================================
export const processingModalStyles = (theme) => ({
  dialogContent: {
    position: 'relative',
    minHeight: '400px',
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.85)',
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backdropFilter: 'blur(2px)',
  },
  chapterItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    borderBottom: '1px solid #e0e0e0',
    '&:last-child': {
      borderBottom: 'none',
    },
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  chapterInfo: {
    flex: 1,
    marginRight: '16px',
  },
  chapterTitle: {
    fontWeight: 500,
    marginBottom: '4px',
  },
  chapterMeta: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.75rem',
  },
  chapterActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  errorBox: {
    padding: '16px',
    textAlign: 'center',
    color: '#f44336',
  },
  emptyBox: {
    padding: '32px 16px',
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.54)',
  },
  statusChip: {
    marginLeft: '8px',
  },
  headerInfo: {
    padding: '0 0 16px 0',
    borderBottom: '1px solid #e0e0e0',
    marginBottom: '16px',
  },
  fieldset: {
    border: '1px solid #e0e0e0',
    borderRadius: 4,
    margin: '20px 0 8px',
    padding: '10px 14px 14px',
  },
  legend: {
    padding: '0 6px',
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.85rem',
  },
  formControl: {
    margin: '12px 0',
  },
  statusLoading: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '16px 0',
  },
})



// WEBPACK FOOTER //
// ./src/containers/BookVectorization/ProcessingModal/styles.js